<template>
    <div class="one-among-area two-among-area pt-100 pb-70" id="service">
        <div class="container">
            <div class="one-section-title">
                <span class="sub-title">¿POR QUÉ ELEGIRNOS?</span>
                <h3>Experiencia y rapidez al servicio de tu impresión digital</h3>
                <p> En Plotix somos especialistas en servicio técnico, mantenimiento y venta de tintas y repuestos para impresión digital.
Trabajamos para que tus equipos funcionen sin interrupciones, con el mejor rendimiento y calidad en cada impresión.
Nuestro equipo técnico altamente capacitado y nuestro servicio rápido y confiable te brindan el soporte que necesitás para mantener tu operación en marcha y sin demoras.</p>
                
            </div>
            <div class="row">
                <div class="col-sm-6 col-lg-4">
                    <div class="among-item">
                        <div class="among-top">
                            <img src="../../assets/img/resources/container1.png" alt="Among">
                            <div class="among-icon">
                                <i class='bx bx-wrench'></i>
                            </div>
                        </div>
                        <div class="among-bottom">
                            <h3>Soporte técnico confiable y profesional</h3>
                            <p>En Plotix contamos con un equipo técnico experto en instalación, diagnóstico y reparación de equipos de impresión digital.
                            Ofrecemos mantenimiento preventivo y correctivo para asegurar el funcionamiento continuo de tus impresoras.
                            Nuestra prioridad es tu tranquilidad: nos encargamos de los detalles técnicos para que te enfoques en imprimir sin interrupciones.</p>
                            <a href="tel:+34 623 61 51 28">
                                ME INTERESA!
                                <i class="bx bx-right-arrow-alt"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <div class="among-item">
                        <div class="among-top">
                            <img src="../../assets/img/resources/container2.png" alt="Among">
                            <div class="among-icon">
                                <i class='bx bx-cart-alt'></i>
                            </div>
                        </div>
                        <div class="among-bottom">
                            <h3>Repuestos originales y soporte especializado</h3>
                            <p>Disponemos de una amplia gama de repuestos, consumibles y materiales originales y compatibles para todas las marcas líderes del mercado.
                            Nuestros especialistas te asesoran para elegir los insumos adecuados según tus necesidades, garantizando rendimiento, durabilidad y calidad en cada impresión.</p>
                            <a href="tel:+34 623 61 51 28">
                                ME INTERESA!
                                <i class="bx bx-right-arrow-alt"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <div class="among-item">
                        <div class="among-top">
                            <img src="../../assets/img/resources/container3.png" alt="Among">
                            <div class="among-icon">
                                <i class='bx bx-stopwatch'></i>
                            </div>
                        </div>
                        <div class="among-bottom">
                            <h3>Rapidez y atención personalizada</h3>
                            <p>Sabemos que cada cliente es diferente. Por eso, brindamos atención personalizada, con respuesta rápida y soluciones adaptadas a cada situación.
                            Nuestro compromiso es construir relaciones de confianza y largo plazo, ofreciendo un servicio técnico cercano, humano y orientado a resultados.</p>
                            <a href="tel:+34 623 61 51 28">
                                ME INTERESA!
                                <i class="bx bx-right-arrow-alt"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WeHaveOffer'
}
</script>